import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from 'react';
export const useDebounceKeyword = (value, t0) => {
  const $ = _c(4);
  const delay = t0 === undefined ? 300 : t0;
  const [debounceKeyword, setDebounceKeyword] = useState(value);
  let t1;
  let t2;
  if ($[0] !== delay || $[1] !== value) {
    t1 = () => {
      const handler = setTimeout(() => setDebounceKeyword(value), delay);
      return () => clearTimeout(handler);
    };
    t2 = [value, delay];
    $[0] = delay;
    $[1] = value;
    $[2] = t1;
    $[3] = t2;
  } else {
    t1 = $[2];
    t2 = $[3];
  }
  useEffect(t1, t2);
  return debounceKeyword;
};